import angular from "angular";
import angularAnimate from "angular-animate";

angular
    .module('lessonsModal.component', [angularAnimate])
    .component('lessonsModal', {
        controller: ['$timeout', '$interval', '$http', 'notifier', controller],
        template: require('./lessons-modal.component.html'),
        bindings: {
            token: '@',
            invite: '<',
        }
    });

function controller($timeout, $interval) {

    var $ctrl = this;


    $ctrl.$onInit = function () {

        $timeout(function () {
            $ctrl.visible = true;
            $ctrl.slideNumber = 'first'
            $ctrl.autoplay = $interval(function () {
                if ($ctrl.slideNumber == 'first') {
                    $ctrl.slideNumber = 'second'
                    return
                }
                if ($ctrl.slideNumber == 'second') {
                    $ctrl.slideNumber = 'third'
                    return
                }
                if ($ctrl.slideNumber == 'third') {
                    $ctrl.slideNumber = 'four'
                    $interval.cancel($ctrl.autoplay);
                    return
                }

            }, 6000);
        }, 3000);

    };

    $ctrl.moveSlide = function (value) {

        if (value == '') {
            if ($ctrl.slideNumber == 'first') {
                $ctrl.slideNumber = 'second'
                return
            }
            if ($ctrl.slideNumber == 'second') {
                $ctrl.slideNumber = 'third'
                return
            }
            if ($ctrl.slideNumber == 'third') {
                $ctrl.slideNumber = 'four'
                return
            }
        }

        if (value == 'first') {
            $ctrl.slideNumber = 'first'
        }
        if (value == 'second') {
            $ctrl.slideNumber = 'second'
        }
        if (value == 'third') {
            $ctrl.slideNumber = 'third'
        }
        if (value == 'four') {
            $ctrl.slideNumber = 'four'
        }
    }

}



export default "lessonsModal.component";


// WEBPACK FOOTER //
// ./resources/assets/modules/lessons-modal/lessons-modal.component.js